import { useNode } from "@craftjs/core";
import React, { useEffect, useState } from "react";
import { ASSETS } from "../../../../utils/config";
import {
  goToUrl,
  percentageToSlider,
  sliderToPercentage,
} from "../../../../utils/helpers";
import CustomSwitch from "../../../CustomSwitch";
import Input from "../../../Input";
import ColorPopup from "../../../SegmentBuilder/Shared/ColorPopup";
import BlockAlignment from "../../../SegmentBuilder/Shared/BlockAlignment";
import Tabs from "../../../Tabs";
import TextView from "../../../TextView";
import MarginBox from "../../Shared/MarginBox";
import MediaSelection from "../../Shared/MediaSelection";
import SettingsSlider from "../../Shared/SettingsSlider";
import UploadedMedia from "../../Shared/UploadedMedia";
import ShareWithBorder from "../../../../assets/icons/ShareWithBorder";
import { useDispatch, useSelector } from "react-redux";
import { updateImageStyles } from "../../../../redux/reducers/PrevStylesCopy/CodeblockDefaultStyles";

const ImageSettings = () => {
  const {
    actions: { setProp },
    width,
    isApplyMarginOnAllSides,
    margin,
    allSideMargin,
    borderRadius,
    borderColor,
    borderWidth,
    src,
    title,
    image,
    showImageTitle,
    hyperlink,
    showHyperlink,
    dropShadowColor,
    originalSrc,
    alignment, // New prop
    isLoading,
  } = useNode((node) => ({
    width: node.data.props.width,
    isApplyMarginOnAllSides: node.data.props.isApplyMarginOnAllSides,
    margin: node.data.props.margin,
    allSideMargin: node.data.props.allSideMargin,
    borderRadius: node.data.props.borderRadius,
    borderWidth: node.data.props.borderWidth,
    borderColor: node.data.props.borderColor,
    src: node.data.props.src,
    image: node.data.props.image,
    title: node.data.props.title,
    showImageTitle: node.data.props.showImageTitle,
    hyperlink: node.data.props.hyperlink,
    showHyperlink: node.data.props.showHyperlink,
    dropShadowColor: node.data.props.dropShadowColor,
    originalSrc: node.data.props.originalSrc || node.data.props.src,
    alignment: node.data.props.alignment, // New prop
    isLoading: node.data.props.isLoading,
  }));

  const dispatch = useDispatch();
  const { image: imageProps } = useSelector((state) => state.codeblockStyles);

  const mainTabs = ["Image Selection", "Image Layout"];
  const [selectedTab, setSelectedTab] = useState(mainTabs[0]);

  // useEffect(() => {
  //   // When the component mounts, update the imageProps in Redux
  //   // This ensures the latest property values are synchronized to global state
  //   const updatedImageProps = {
  //     ...imageProps,
  //     margin: margin || imageProps.margin,
  //     isApplyMarginOnAllSides: isApplyMarginOnAllSides,
  //     allSideMargin: allSideMargin || imageProps.allSideMargin,
  //     borderRadius: borderRadius || imageProps.borderRadius,
  //     borderWidth: borderWidth || imageProps.borderWidth,
  //     borderColor: borderColor || imageProps.borderColor,
  //     dropShadowColor: dropShadowColor || imageProps.dropShadowColor,
  //     alignment: alignment || imageProps.alignment,
  //     showImageTitle: showImageTitle,
  //     hyperlink: hyperlink,
  //     showHyperlink: showHyperlink,
  //     width: width || imageProps.width
  //   };

  //   // Dispatch to update the global image props
  //   dispatch(updateImageStyles(updatedImageProps));
  // }, []);

  const handleAdjustment = (side, operation) => {
    const newValue =
      operation === "increase" ? margin[side] + 1 : margin[side] - 1;
    if (newValue >= 0) handleChange("margin", newValue, side);
  };

  const handleChange = (type, value, side) => {
    setProp((props) => {
      switch (type) {
        case "width":
          props.width = sliderToPercentage(value);
          break;
        case "margin":
          if (value >= 0 && value <= 100) props.margin[side] = value;
          break;
        case "allSideMargin":
          props.allSideMargin = value;
          break;
        case "marginCheckbox":
          props.isApplyMarginOnAllSides = !props.isApplyMarginOnAllSides;
          break;
        case "border":
          props.borderRadius = value;
          break;
        case "borderColor":
          props.borderColor = value;
          break;
        case "resetColor":
          props.borderColor = null;
          break;
        case "borderWidth":
          props.borderWidth = value;
          break;
        case "image":
          props.image = { ...props.image, ...value };
          // Set loading state based on the uploaded file data only if loading key exists
          if (value.hasOwnProperty("loading")) {
            props.isLoading = value.loading !== false;
          }
          // if (!props.originalSrc) props.originalSrc = value;
          break;
        case "title":
          props.image = { ...props.image, title: value };
          break;
        case "showImageTitle":
          props.showImageTitle = !props.showImageTitle;
          break;
        case "showHyperlink":
          props.showHyperlink = !props.showHyperlink;
          break;
        case "hyperlink":
          props.hyperlink = value;
          break;
        case "dropShadowColor":
          props.dropShadowColor = value;
          break;
        case "resetShadow":
          props.dropShadowColor = null;
          break;
        case "alignment":
          props.alignment = value;
          break;
        case "imageRemove":
          props.image = {};
          break;
      }
    }, 500);

    const updatedImageProps = { ...imageProps };

    switch (type) {
      case "width":
        updatedImageProps.width = sliderToPercentage(value);
        break;
      case "margin":
        if (side && value >= 0 && value <= 100) {
          updatedImageProps.margin = {
            ...updatedImageProps.margin,
            [side]: value,
          };
        }
        break;
      case "allSideMargin":
        updatedImageProps.allSideMargin = value;
        break;
      case "marginCheckbox":
        updatedImageProps.isApplyMarginOnAllSides = !isApplyMarginOnAllSides;
        break;
      case "border":
        updatedImageProps.borderRadius = value;
        break;
      case "borderColor":
        updatedImageProps.borderColor = value;
        break;
      case "resetColor":
        updatedImageProps.borderColor = null;
        break;
      case "borderWidth":
        updatedImageProps.borderWidth = value;
        break;
      case "dropShadowColor":
        updatedImageProps.dropShadowColor = value;
        break;
      case "resetShadow":
        updatedImageProps.dropShadowColor = null;
        break;
      case "alignment":
        updatedImageProps.alignment = value;
        break;
      case "showImageTitle":
        updatedImageProps.showImageTitle = !showImageTitle;
        break;
      case "hyperlink":
        updatedImageProps.hyperlink = value;
        break;
      case "showHyperlink":
        updatedImageProps.showHyperlink = !showHyperlink;
        break;
    }

    console.log("Updating image props in Redux:", type, updatedImageProps);
    dispatch(updateImageStyles(updatedImageProps));
  };

  const handleImageChange = (type, value) => {
    handleChange(type, value);
    setProp((props) => {
      props.originalSrc = value;
    });
  };

  const imageSelected = image.src || src;

  const renderImageSelection = () => {
    return (
      <>
        {imageSelected && (
          <UploadedMedia
            type="image"
            originalImage={originalSrc?.src}
            media={image.src || src}
            title={image.title || title}
            onChange={(val) => handleChange("title", val)}
            showTitle={showImageTitle}
            handleCheckbox={() => handleChange("showImageTitle")}
            handleEditMedia={(value) => handleChange("image", value)}
            handleMediaRemove={() => handleChange("imageRemove")}
          />
        )}
        <MediaSelection
          type={"image"}
          isGifAllowed
          src={src}
          handleChange={handleImageChange}
          handleTitle={(val) => handleChange("title", val)}
        />
      </>
    );
  };

  const renderImageLayout = () => {
    return (
      <>
        <TextView variant="subtitle" style={{ marginBottom: 10 }}>
          Add Hyperlink to Image{" "}
          <CustomSwitch
            checked={showHyperlink}
            onChange={() => handleChange("showHyperlink")}
          />
        </TextView>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr auto",
            gridGap: 10,
          }}
        >
          <Input
            variant="secondary"
            placeholder="Paste link here"
            value={hyperlink}
            onChange={(e) => handleChange("hyperlink", e.target.value)}
          />
          <ShareWithBorder
            style={{ marginTop: 14, cursor: "pointer" }}
            onClick={() => {
              goToUrl(hyperlink);
            }}
          />
        </div>
        <BlockAlignment
          selectedAlignment={alignment}
          setSelectedAlignment={(value) => handleChange("alignment", value)}
        />

        <MarginBox
          margin={margin}
          increaseMargin={(side) => handleAdjustment(side, "increase")}
          decreaseMargin={(side) => handleAdjustment(side, "decrease")}
          handleMarginChange={(side, value) =>
            handleChange("margin", value, side)
          }
          isApplyMarginOnAllSides={isApplyMarginOnAllSides}
          allSideMargin={allSideMargin}
          handleMarginCheckBox={() => handleChange("marginCheckbox")}
          handleSliderMarginChange={(value) =>
            handleChange("allSideMargin", value)
          }
        />

        <SettingsSlider
          title="Resizing"
          sliderValue={percentageToSlider(width)}
          onValueChange={(val) => handleChange("width", val)}
          min={10}
          max={100}
          valueLabel={"%"}
        />
        <SettingsSlider
          title="Corner Rounding"
          sliderValue={borderRadius}
          onValueChange={(val) => handleChange("border", val)}
          min={0}
          max={20}
        />

        <ColorPopup
          title="Border"
          background={borderColor}
          handleChangeBackgroundColor={(val) =>
            handleChange("borderColor", val)
          }
          resetBackgroundColor={() => handleChange("resetColor")}
          sliderBoxTitle={"Border Width"}
          sliderValue={borderWidth}
          sliderChange={(val) => handleChange("borderWidth", val)}
          sliderMinValue={0}
          sliderMaxValue={8}
          sliderSymbol={"px"}
          isHideGradient={true}
          showSuggestedColorPalette={true}
          isBorderSlider
        />

        <ColorPopup
          title="Drop Shadow"
          background={dropShadowColor}
          handleChangeBackgroundColor={(val) =>
            handleChange("dropShadowColor", val)
          }
          resetBackgroundColor={() => handleChange("resetShadow")}
          showSlider={false}
          isHideGradient={true}
          showSuggestedColorPalette={true}
        />
      </>
    );
  };

  return (
    <>
      <Tabs
        categories={mainTabs}
        selectedCategory={selectedTab}
        onCategoryChange={(_, val) => setSelectedTab(val)}
        tabStyle={{ maxWidth: "50%" }}
        disabledCategories={imageSelected ? [] : [mainTabs[1]]}
      />

      <div style={{ marginBottom: 20 }} />

      {selectedTab === mainTabs[0] && renderImageSelection()}
      {selectedTab === mainTabs[1] && renderImageLayout()}
    </>
  );
};

export default ImageSettings;
